import $ from "jquery";
import 'bootstrap';
import './assets/styles/main.scss';
import './assets/scripts/stsbuffercrane.js';

console.log('app.js loaded');

$(document).ready(() => {
  console.log('jquery works!');
});